

















import Vue from 'vue'
import RadioChecked from '@/assets/svgs/radio_button_checked.svg?inline'
import RadioUnchecked from '@/assets/svgs/radio_button_unchecked.svg?inline'

interface Data {}

interface Methods {}

interface Computed {}

interface Props {
  id: string
  name: string
  label: string
  value: string
  selected: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'Radio',
  model: {
    prop: 'selected',
    event: 'input'
  },
  props: {
    id: String,
    name: String,
    label: String,
    value: String,
    selected: String
  },
  components: {
    RadioChecked,
    RadioUnchecked
  }
})
